<template>
  <v-container >
    <v-row>
      <v-col cols="12">

        <v-card elevation="10" class="ma-2">
          <v-toolbar dark dense color="blue-grey">
            <v-toolbar-title>{{modo}} Planta {{ idplanta }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
              class="ma-2" small
              color="info"
              @click="regresar">
              <v-icon>mdi-reply</v-icon>
              </v-btn>


              <v-btn align="right"
                color="success" dark small
                class="ma-2"
                @click="saveInfo"
                >PROCESAR<v-icon class="ma-2">mdi-check-circle</v-icon>
              </v-btn>

            </v-toolbar>

          <v-row>
          
            <v-col cols="6" class="ma-2">
          
              <v-text-field
                prepend-icon="mdi-pencil"
                class="ma-3"
                v-model="nomplanta"
                label="Nombre del la Planta"
              ></v-text-field>

              <v-text-field
                prepend-icon="mdi-account"
                class="ma-3"
                v-model="codplanta"
                label="Código de planta"
              ></v-text-field>
              
              
            </v-col>
            
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions} from 'vuex'

export default{
  data(){
    return {
      nomplanta:'',
      codplanta:'',
      //MODO
      nModo:'',
      modo:'',
      idproy :null,
      idproyecto:'',

      idplanta:''
    }
  },

  created(){

    // this.idcita = ''
    console.log('router', this.$route.params)
    // this.idcita = this.$route.params.idcita
    let ruta = this.$route.params.idplanta

    //MODO EDITAR
    if ( ruta !== undefined ){
      this.nModo=2
      this.readonly= true

      this.cargarInfo(this.$route.params)
      this.modo = 'Editar'

    } else {
      console.log("nuevo")
      //VALORES INICIALES ALTA
      this.nModo = 1
      this.modo  = 'Nueva'
    }

  },

  computed:{
    validaInfo(){
      return  this.nomplanta   !== ''
    },
  },

  methods: {
    ...mapActions("snackbar", ["showSnack"]),

    cargarInfo(planta) {
      console.log("planta", planta)
      this.idplanta =  planta.idplanta
      this.nomplanta = planta.nomplanta
      this.codplanta = planta.codplanta
    },

    saveInfo(){
      console.log("saveInfo")
      if (!this.validaInfo){
        this.showSnack({
          text: "Debes registrar el nombre de la planta ",
          color: "orange",
          timeout: 2000,
        });
        return
      }

      var payload = {
        // idplanta: this.idplanta,
        nomplanta: this.nomplanta,
        codplanta: this.codplanta
         
      }

      console.log("payload", payload)
      // this.addCita(payload)

      //NUEVO
      if (this.nModo == 1) {
        //Dedinir db name
        this.$http.post('v2/insert.planta', payload).then( response =>{
          console.log("response" ,response)

          this.showSnack({
            text: "Planta agregada correctamente",
            color: "success",
            timeout: 2000,
          });

          this.limpiarPlanta()
          setTimeout (() => this.$router.push({name:'catplantas'}),2000);
        }).catch(error=>{
          console.log(error)
          this.showSnack({
            text: "Problema para grabar"+ error,
            color: "error",
            timeout: 2000,
          });
   
        })
      }

      //EDITAR
      if ( this.nModo == 2 ){
        this.$http.put('v2/update.planta/' + this.idplanta, payload).then(() =>{
          this.showSnack({
            text: "Proyecto grabado correctamente ",
            color: "success",
            timeout: 2000,
          });
          setTimeout (() => this.$router.push({name:'catplantas'}),2000);
          this.limpiarPlanta()
        }).catch(error=>{
          this.showSnack({
            text: "Problema para grabar."+ error.error,
            color: "error",
            timeout: 2000,
          });
          console.log(error)
        })
      }

    },
    created(){
      // this.idcita = ''
      console.log('router', this.$route.params)
      // this.idcita = this.$route.params.idcita
      let ruta = this.$route.params.nomina
      //MODO EDITAR
      if ( ruta !== undefined ){
        this.nModo=2
        this.readonly= true
        this.cargarInfo(this.$route.params)
        this.modo = 'Editar'
      } else {
        console.log("nuevo")
        //VALORES INICIALES ALTA
        this.nModo = 1
        this.modo  = 'Nueva'
      }
    },
    computed:{
      validaInfo(){
        return  this.nomplanta   !== ''
      },
    },

    regresar(){
      this.$router.push({name:'catplantas'})
    },

    limpiarPlanta() {

      this.nomplanta = ''
      this.codplanta = ''
    }
  }
    
}
</script>